import { render, staticRenderFns } from "./customer-portal.vue?vue&type=template&id=4b6c13ae&"
import script from "./customer-portal.vue?vue&type=script&lang=js&"
export * from "./customer-portal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports